import { Box, CircularProgress, Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useCallback, useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';

import { redmineGet } from 'common/api';
import Page from 'common/shared-ui/src/components/Page';

import SettingsProjectTasks from './SettingsProjectTasks/SettingsProjectTasks';
import SettingsTasksTypes from './SettingsTasksTypes/SettingsTasksTypes';
import SettingsUpperLine from './SettingsUpperLine/SettingsUpperLine';

// Original class: settingsWrap
const StyledSettingsWrap = styled(Grid)(({ theme }) => ({
  width: '100%',
  background: '#FFFFFF',
  borderRadius: theme.spacing(2),
  boxShadow: '0px 5px 10px -8px #212346',
}));
// Original class: settingsMiddleContainer
const StyledSettingsMiddleContainer = styled(Grid)(theme => ({
  width: '100%',
}));
// Original class: settingsLowerContainer
const StyledSettingsLowerContainer = styled(Grid)(({ theme }) => ({
  width: '100%',
  background: '#FFFFFF',
  borderRadius: theme.spacing(2),
  boxShadow: '0px 5px 10px -8px #212346',
}));

const SettingsContainer = ({ intl }) => {
  const [info, setInfo] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const pageTitle = intl.formatMessage({ id: 'page_title_user_settings' });

  const userInfo = useCallback(async () => {
    const { data } = await redmineGet('my/account.json');
    setInfo(data);
    setIsLoading(false);
  }, []);
  useEffect(() => {
    userInfo();
  }, [userInfo]);
  return (
    <>
      {!isLoading ? (
        <Page title={pageTitle} width='100%'>
          <Box sx={{ width: '100%' }}>
            <Grid container>
              <Grid
                container
                spacing={1}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Typography variant='h1'>
                  {info.user.lastname} {info.user.firstname}
                </Typography>
              </Grid>
            </Grid>
            <StyledSettingsWrap
              container
              wrap='wrap'
              sx={{
                marginTop: 5,
                position: 'relative',
                padding: 5,
              }}
            >
              {info.user.custom_fields.map(inf => (
                <SettingsUpperLine
                  key={inf.id}
                  header={inf.name}
                  content={inf.value}
                />
              ))}
            </StyledSettingsWrap>
            <StyledSettingsMiddleContainer
              container
              wrap='nowrap'
              sx={{
                position: 'relative',
                gap: 5,
              }}
            >
              <SettingsProjectTasks />
            </StyledSettingsMiddleContainer>
            <StyledSettingsLowerContainer
              item
              container
              direction='column'
              xs={12}
              sx={{
                justifyContent: 'space-between',
                marginTop: 5,
                marginBottom: 5,
                gap: 7,
              }}
            >
              <SettingsTasksTypes />
            </StyledSettingsLowerContainer>
          </Box>
        </Page>
      ) : (
        <Grid
          container
          sx={{
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100vh',
          }}
        >
          <CircularProgress color='secondary' />
        </Grid>
      )}
    </>
  );
};

export default injectIntl(SettingsContainer);
